import { apiClient } from "../services/api/client.api";

const CACHE_MAX_SIZE = 200; // 最大缓存数量

interface CacheItem {
    data: any;
    timestamp: number;
}

const cache = new Map<string, CacheItem>();

export const cacheGet = async (key: string, validTime: number): Promise<any> => {
    const cached = cache.get(key);
    const currentTime = (Date.now() / 1000) | 0; // 当前时间戳，单位为秒
    // 2038 年这个写法会有问题，到时候要改一下

    if (cached && currentTime - cached.timestamp < validTime) {
        return cached.data;
    }

    const data = await apiClient.get(key);
    cache.set(key, { data, timestamp: currentTime });
    // 限制缓存大小
    if (cache.size > CACHE_MAX_SIZE) {
        const firstKey = cache.keys().next().value;
        if (firstKey) {
            cache.delete(firstKey);
        }
    }
    return data;
}